import type { PageType } from 'types/publishedAssets';
import type { UrlParams } from 'types/urlParams';
import { isAutomatedBrowser } from './isAutomatedBrowser';

interface ShouldTrackUmamiInput {
  page: PageType | undefined;
  umamiWebsiteId: string | undefined;
  urlParams: UrlParams | undefined;
}

export const shouldTrackUmami = ({ page, umamiWebsiteId, urlParams }: ShouldTrackUmamiInput): boolean => {
  if (!page) return false;
  if (!umamiWebsiteId) return false;
  if (isAutomatedBrowser()) return false;
  if (urlParams?.preview) return false;
  if (urlParams?.previewLink) return false;
  return true;
};
